import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

export { LoadingSpinner } from './LoadingSpinner';
export const loading = () => <LoadingSpinner />; // initialize loading